import baselineOnboardingRoutes from '@/pages/baseline/onboarding/routes'
import v1OnboardingRoutes from '@/pages/v1/onboarding/routes'
import v2OnboardingRoutes from '@/pages/v2/onboarding/routes'
import type { ABTestRouteConfig } from '@app-studio-web/ui/types/abtest'

interface RouteDefinition {
  path?: string
  children?: RouteDefinition[]
}

function extractChildPaths(onboardingRoutesDef: RouteDefinition[]): string[] {
  const parent = onboardingRoutesDef[0]
  if (!parent || !parent.children) return []
  return parent.children
    .filter((child: RouteDefinition) => child.path)
    .map((child: RouteDefinition) => child.path as string)
}

const baselineOrder = (baselineOnboardingRoutes as RouteDefinition[])
  .map((route) => route.path)
  .filter((path): path is string => !!path)

const v1Order = extractChildPaths(v1OnboardingRoutes as RouteDefinition[])
const v2Order = extractChildPaths(v2OnboardingRoutes as RouteDefinition[])

export const decluttifyABTestRouteConfig: ABTestRouteConfig = {
  baseline: baselineOrder,
  variants: {
    v1: v1Order,
    v2: v2Order,
  },
}

export function getABTestConfig() {
  const clientSecret = import.meta.env.VITE_CONFIDENCE_CLIENT_SECRET as string
  const flagName =
    (import.meta.env.VITE_CONFIDENCE_FLAG_NAME as string) ||
    'decluttify-onboarding-variant'

  if (!clientSecret) {
    console.warn('No Confidence client secret provided, A/B testing disabled')
    return null
  }

  return {
    clientSecret,
    flagName,
    defaultVariant: 'baseline',
    enabledVariants: ['baseline', 'v1', 'v2'],
  }
}
